export default __webpack_public_path__ + "static/media/verified.6644fcbd.svg";